import { styled } from '../theme';
import Text from './Text';

const Link = styled(Text.withComponent('a'))(({ theme }) => ({
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme.color.primary1,
    ':hover, :focus': {
        color: theme.color.primary2,
    },
    ':active': {
        color: theme.color.primary3,
    },
}));

export default Link;
